import PropTypes from "prop-types";

export default function Home({ language }) {
  return null;
}

Home.propTypes = {
  language: PropTypes.oneOf(["en", "it"]),
};
